export default `
  mutation removeEnterpriseCustomer($enterpriseCustomerId: String!) {
    removeEnterpriseCustomer(enterpriseCustomerId: $enterpriseCustomerId) {
      success
      message
    }
  }
`
